import { Trans, useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { getCurrency } from 'src/services/util';

type Props = {
  product: CheckoutProductData;
};

export default function PromotionChart({ product }: Props): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <div className="mt-8">{t('payment/sale_promotion_title')}</div>
      <div className="mt-4 w-full rounded-sm flex">
        <div className="w-1/3">
          <div className="w-full h-8 bg-light-gray-1 border border-topaz rounded-sm inline-flex justify-center items-center stripe-topaz">
            <span className="N_12_R text-topaz">
              <NumberFormat
                value={product.promotionAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={getCurrency(product.region)}
              />
            </span>
          </div>
          <div className="relative mt-2 w-full border-l border-r border-topaz h-2 flex items-center justify-center">
            <div className="absolute w-full border-b border-topaz"></div>
            <div className="N_12_M text-topaz z-10 px-2 bg-white">
              <Trans i18nKey="payment/sale_promotion_sale_count" values={{ count: product.promotionCycle }}></Trans>
            </div>
          </div>
        </div>
        <div className="flex-auto">
          <div className="w-full h-8 bg-light-gray-1 rounded-sm inline-flex justify-center items-center">
            <span className="N_12_R text-brown-grey">
              <NumberFormat value={product.amount} displayType={'text'} thousandSeparator={true} prefix={getCurrency(product.region)} />
            </span>
          </div>
          <div className="relative mt-2 w-full border-l border-r border-ice-blue h-2 flex items-center justify-center">
            <div className="absolute w-full border-b border-ice-blue"></div>
            <div className="N_12_M text-brown-grey z-10 px-2 bg-white">{t('payment/sale_promotion_sale_after')}</div>
          </div>
        </div>
      </div>
    </>
  );
}
